module.exports = __webpack_public_path__ + "img/prdimg.5a713f03.jpg";